export const categories = [
  { id: "1", label: "Conjuntos", count: 5 },
  { id: "2", label: "Blazers", count: 1 },
  { id: "3", label: "Calças", count: 1 },
  { id: "4", label: "Croppeds", count: 1 },
];

export const priceRanges = [
  { id: "p1", label: "Até R$ 100,00" },
  { id: "p2", label: "R$ 100,00 – R$ 150,00" },
  { id: "p3", label: "R$ 150,00 – R$ 200,00" },
  { id: "p4", label: "R$ 200,00 – R$ 300,00" },
  { id: "p5", label: "Acima de R$ 300,00" },
];

export const sortOptions = [
  { id: "relevancia", label: "Seleção da loja" },
  { id: "novidades", label: "Novidades" },
  { id: "menor", label: "Menor preço" },
  { id: "maior", label: "Maior preço" },
];

export interface ProductVariant {
  id: number;
  price: number;
  compareAtPrice?: number;
  inStock: boolean;
  stock?: number | null;
  values: Record<string, string>;
  imageId?: number;
}

export interface Product {
  inStock?: boolean;
  id: number;
  name: string;
  price: number;
  compareAtPrice?: number;
  installments: number;
  installmentValue: number;
  image: string;
  images?: string[];
  imageIds?: number[];
  description?: string;
  color: string;
  material: string;
  variantId?: number;
  categoryIds?: number[];
  attributes?: Record<string, string[]>;
  variants?: ProductVariant[];
}

const SIZES = ["P", "M", "G"];

interface DemoProduct {
  id: number;
  name: string;
  price: number;
  colors: string[];
  category: number;
  photos: string;
  photoCount?: number;
  description: string;
}

// Catálogo de demonstração: usado só enquanto a loja não tem backend configurado.
// Peças e fotos reais da Bozzetti Store; os preços são os do cadastro antigo
// (Bozzetti-Store-V2/products.json) e precisam ser confirmados.
const demo = ({ id, name, price, colors, category, photos, photoCount = 3, description }: DemoProduct): Product => {
  const images = Array.from({ length: photoCount }, (_, index) => `${import.meta.env.BASE_URL}produtos/${photos}-${index + 1}.webp`);
  const variants = colors.flatMap((color, colorIndex) =>
    SIZES.map((size, sizeIndex) => ({
      id: id * 1000 + colorIndex * 10 + sizeIndex,
      price,
      inStock: true,
      values: { Tamanho: size, Cor: color },
    }))
  );
  return {
    id,
    name,
    price,
    installments: 12,
    installmentValue: price / 12,
    image: images[0],
    images,
    description: `<p>${description}</p>`,
    color: colors[0],
    material: "",
    variantId: variants[0].id,
    categoryIds: [category],
    attributes: { Tamanho: SIZES, Cor: colors },
    variants,
  };
};

const ALL_COLORS = ["Preto", "Off White", "Nude", "Azul", "Cinza"];
const first = (color: string) => [color, ...ALL_COLORS.filter((item) => item !== color)];

export const products: Product[] = [
  demo({ id: 1, name: "Conjunto 3 Peças Calça, Cropped e Blazer", price: 270, colors: first("Off White"), category: 1, photos: "conjunto-3-pecas", description: "Conjunto de três peças em alfaiataria: calça, cropped e blazer, para usar junto ou combinar separadamente." }),
  demo({ id: 2, name: "Conjunto Colete e Calça", price: 170, colors: ["Preto"], category: 1, photos: "conjunto-colete-preto", description: "Conjunto em alfaiataria com colete e calça, uma combinação elegante para o dia a dia." }),
  demo({ id: 3, name: "Conjunto Shorts e Colete", price: 140, colors: ["Preto"], category: 1, photos: "conjunto-shorts-colete", description: "Conjunto em alfaiataria com shorts e colete, leve e sofisticado." }),
  demo({ id: 4, name: "Conjunto Cropped e Calça", price: 120, colors: ["Nude"], category: 1, photos: "conjunto-calca-cropped", description: "Conjunto em alfaiataria com cropped e calça, de visual alongado e elegante." }),
  demo({ id: 5, name: "Conjunto Shorts e Cropped", price: 100, colors: ["Off White"], category: 1, photos: "conjunto-shorts-cropped", photoCount: 2, description: "Conjunto em alfaiataria com shorts e cropped, para looks leves e arrumados." }),
  demo({ id: 6, name: "Blazer de Alfaiataria", price: 100, colors: first("Azul"), category: 2, photos: "blazer", description: "Blazer em alfaiataria, uma peça versátil para completar o look." }),
  demo({ id: 7, name: "Calça de Alfaiataria", price: 100, colors: first("Preto"), category: 3, photos: "calca", description: "Calça em alfaiataria, fácil de combinar com blazers, coletes e croppeds." }),
  demo({ id: 8, name: "Cropped Corselet", price: 70, colors: ["Off White", "Preto", "Nude"], category: 4, photos: "cropped-corselet", description: "Cropped corselet em alfaiataria, para usar sozinho ou por baixo do blazer." }),
];
